/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ThreePersons2Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M0.5,9.5 L0.5,12.5 C0.5,13.325 0.675,14 1.5,14 L1.5,18.5 L4.5,18.5 L4.5,14 C5.324,14 5.499,13.324 5.5,12.5 L5.5,9.5 L0.5,9.5 Z" />
      <path d="M18.5,9.5 L18.5,12.5 C18.5,13.325 18.675,14 19.5,14 L19.5,18.5 L22.5,18.5 L22.5,14 C23.324,14 23.499,13.324 23.5,12.5 L23.5,9.5 L18.5,9.5 Z" />
      <path d="M8.5,9.5 L15.5,9.5 L15.5,14.5 C15.5,15.6 14.6,16.5 13.5,16.5 L13.5,22.5 L10.5,22.5 L10.5,16.5 C9.399,16.5 8.5,15.6 8.5,14.5 L8.5,9.5 Z" />
      <path d="M4.5,6 C4.5,6.828 3.828,7.5 3,7.5 C2.172,7.5 1.5,6.828 1.5,6 C1.5,5.172 2.172,4.5 3,4.5 C3.828,4.5 4.5,5.172 4.5,6 Z" />
      <path d="M22.5,6 C22.5,6.828 21.828,7.5 21,7.5 C20.172,7.5 19.5,6.828 19.5,6 C19.5,5.172 20.172,4.5 21,4.5 C21.828,4.5 22.5,5.172 22.5,6 Z" />
      <path d="M14.5,5 C14.5,6.381 13.381,7.5 12,7.5 C10.619,7.5 9.5,6.381 9.5,5 C9.5,3.619 10.619,2.5 12,2.5 C13.381,2.5 14.5,3.619 14.5,5 Z" />
    </g>
  </svg>
);

export default ThreePersons2Icon;
